import { AnyAction } from '@reduxjs/toolkit';
import { LOG_ERROR, CLEAR_ERROR } from '@constants/actionTypes';

export interface LogsState {
  logs: unknown[];
}

const initialState: LogsState = {
  logs: [],
};

export default function logsReducers(
  state: LogsState = initialState,
  action: AnyAction
): LogsState {
  switch (action.type) {
    case LOG_ERROR: {
      return {
        logs: [action?.payload, ...state.logs],
      };
    }
    case CLEAR_ERROR: {
      return {
        logs: [],
      };
    }
    default:
      return state;
  }
}
